import React, { useState, useEffect } from "react";
import { Nav, Tab } from 'react-bootstrap'
import { DASHBOARD_CLIENT_DETAIL_EQUITY } from "../../../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import PartnerHoldings from "./PartnerHoldings";
import PartnerNetPosition from "./PartnerNetPosition";
import SmallLoader from "../../../../Components/Common/smallLoader";
import refresh from "../../../../asset/images/refresh.svg"
import { axiosSsoJsonReserv1 } from "../../../../CommonMethhods/axiosPartnerInterceptor";

function PartnerHoldingsNetPosition() {
  const [tabStatus, setTabStatus] = useState("Holdings");
  function handleTab(tab) {
    setTabStatus(tab);
  }
  //destructuring apply
  const PartnerClientCode = localStorage.getItem("ClientId2");
  const storeToken = localStorage.getItem("ssoToken");
  const [holdingData, setHoldingData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [positionData, setPostionData] = useState([])
  const [commonError, setCommonError] = useState(false);
  const [totalValue, setTotalValues] = useState({
    totalCurrent: 0,
    totalInvest: 0,
    totalPnl: 0,
    totalPnlPer: 0,
  });
  const [smallLoaderPdf, setPdfLoader] = useState(false);
  const [smallLoaderExcel, setExcelLoader] = useState(false);

  const getHoldingTableData = async (viewType = "grid") => {
    let clientCode = "";
    if (PartnerClientCode) {
      clientCode = PartnerClientCode;
    }
    if (viewType === "grid") {
      setLoader(true);
    }

    if (viewType === "pdf") {
      setPdfLoader(true);
    }
    if (viewType === "excel") {
      setExcelLoader(true);
    }
    let payloadValue = { ClientCode: clientCode, fileType: viewType };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getHoldingData = await axiosSsoJsonReserv1.post(
        DASHBOARD_CLIENT_DETAIL_EQUITY.Holdings_URL,
        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(getHoldingData?.data);
      // let res = JSON.parse(res);
      console.log(res, "holdingResp");
      let totalCurrent = 0;
      let totalInvest = 0;
      let todaysPnl = 0;
      let pnl = 0;
      if (res?.status === 0) {
        if (viewType === "grid") {
          setCommonError(false);
          // setHoldingData(res?.data?.hold);
          setHoldingData(res?.data);
          res?.data.map((item) => {
            totalCurrent = totalCurrent + item?.value;
            totalInvest = totalInvest + item?.invested;
            todaysPnl = todaysPnl + item?.todaysPnl;
            pnl = pnl + item?.pnl;
          });
          setTotalValues({
            totalCurrent: totalCurrent,
            totalInvest: totalInvest,
            todaysPnl: todaysPnl,
            pnl: pnl,
          });
        }

        if (viewType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
        if (viewType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        if (viewType !== "grid") {
          toast.error(res?.message);
        } else {
          setHoldingData([]);
          setCommonError(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setCommonError(error?.message);
    } finally {
      setLoader(false);
      setExcelLoader(false);
      setPdfLoader(false);
    }
  };

  const getNetPositionTableData = async (viewType = "grid") => {
    let clientCode = "";
    if (localStorage.getItem("clientCode")) {
      clientCode = localStorage.getItem("clientCode");
    }
    if (viewType === "grid") {
      setLoader(true);
    }

    if (viewType === "pdf") {
      setPdfLoader(true);
    }
    if (viewType === "excel") {
      setExcelLoader(true);
    }
    let payloadValue = { ClientCode: clientCode, fileType: viewType };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getpositionData = await axiosSsoJsonReserv1.post(
        DASHBOARD_CLIENT_DETAIL_EQUITY.Position_URL,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getpositionData?.data);
      console.log("response position", res);
      if (res?.status === 0) {
        if (viewType === "grid") {
          setCommonError(false);
          setPostionData(res?.data);
        }

        if (viewType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
        if (viewType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        if (viewType !== "grid") {
          toast.error(res?.message);
        } else {
          setPostionData([]);
          setCommonError(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setCommonError(error?.message);
    } finally {
      setLoader(false);
      setExcelLoader(false);
      setPdfLoader(false);
    }
  };

  const apiCall = () => {
    if (tabStatus == "Holdings") {
      getHoldingTableData("grid");
    } else {
      getNetPositionTableData("grid");
    }
  };

  useEffect(() => {
    apiCall();
  }, [tabStatus]);

  const handleOnClick = (e) => {
    if (e.target.value) {
      if (tabStatus == "Holdings") {
        getHoldingTableData(e.target.value);
      } else {
        getNetPositionTableData(e.target.value);
      }
    }
  };
  // useEffect(() => {
  //   getHoldingTableData("grid");
  // }, []);

  // const handleOnClick = (e) => {
  //   if (e.target.value) {
  //     getHoldingTableData(e.target.value);
  //   }
  // };

  console.log(holdingData, "holdingData");

  return (
    <div className="holding-comp-card positiontab">
      {/* <div className="card-box holdings bottom-25 ">
        <div className="holdings__title card-title d-flex justify-content-between">
          <div className="figure-inlac">
            <h2 className="small-title">{Holdings}</h2>
          </div>

          <div className="btn-wrapper-summary">
            <button
              value="excel"
              onClick={handleOnClick}
              className="summary-btn excel-btn"
            >
              {smallLoaderExcel ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  Excel
                </>
              )}
            </button>
            <button
              className="summary-btn pdf-btn"
              value="pdf"
              onClick={handleOnClick}
            >
              {smallLoaderPdf ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-pdfsvg"></span>
                  PDF
                </>
              )}
            </button>
          </div>
        </div>
        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : (
          <div className="holdings__table scroll-table">
            {holdingData && holdingData.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">{Stock_Symbol}</th>
                    <th scope="col">{Total_Qty}</th>
                    <th scope="col">{Avg_Cost_Price}</th>
                    <th scope="col">{LTP}</th>
                    <th scope="col">{Invested_Value}</th>
                    <th scope="col">{Current_Value}</th>
                    <th scope="col">Today's P&L</th>
                    <th scope="col">{pnl_value}</th>
                  </tr>
                </thead>

                <tbody>
                  {holdingData &&
                    holdingData.map((info, key) => {
                      const {
                        clientId,
                        sym,
                        qty,
                        avgPrice,
                        ltp,
                        invested,
                        value,
                        pnl,
                        todaysPnl,
                      } = info;
                      return (
                        <tr key={key}>
                          <td>{sym || "-"}</td>
                          <td>{qty || 0}</td>
                          <td>{avgPrice || 0}</td>
                          <td>{ltp || 0}</td>
                          <td>{invested ? numDifferentiation(invested) : 0}</td>
                          <td>{value ? numDifferentiation(value) : 0}</td>
                          <td>
                            <span
                              className={
                                todaysPnl == 0
                                  ? "text-muted"
                                  : todaysPnl < 0
                                  ? "red-txt"
                                  : "green-txt"
                              }
                            >
                              {numDifferentiation(todaysPnl) || 0}
                            </span>
                          </td>
                          <td>
                            <span
                              className={
                                pnl == 0
                                  ? "text-muted"
                                  : pnl < 0
                                  ? "red-txt"
                                  : "green-txt"
                              }
                            >
                              {pnl ? numDifferentiation(pnl) : 0.0}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>

                <tbody className="total-holdings">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col">{Total}</th>
                    <th scope="col">
                      {totalValue?.totalInvest
                        ? numDifferentiation(totalValue?.totalInvest)
                        : 0}
                    </th>

                    <th scope="col">
                      {totalValue?.totalCurrent
                        ? numDifferentiation(totalValue?.totalCurrent)
                        : 0}
                    </th>
                    <th
                      scope="col"
                      className={
                        totalValue?.todaysPnl === 0
                          ? "gray-text"
                          : totalValue?.todaysPnl > 0
                          ? "green-txt"
                          : "red-txt"
                      }
                    >
                      {totalValue?.todaysPnl
                        ? numDifferentiation(totalValue?.todaysPnl)
                        : 0}
                    </th>
                    <th
                      scope="col"
                      className={
                        totalValue?.pnl === 0
                          ? "gray-text"
                          : totalValue?.pnl > 0
                          ? "green-txt"
                          : "red-txt"
                      }
                    >
                      {totalValue?.pnl
                        ? numDifferentiation(totalValue?.pnl)
                        : 0.0}{" "}
                      %
                    </th>
                  </tr>
                </tbody>
              </table>
            ) : (
              commonError && (
                <h4 className="no-data">{noDataFound(commonError)}</h4>
              )
            )}
          </div>
        )}
      </div> */}

    <div className="card-box holdings bottom-25 ">
      <div>
          <Tab.Container activeKey={tabStatus}>
            <div className='holdings__title card-title d-flex justify-content-between'>
                <Nav variant="nav tabs page-tabs">
                    <li
                        className="nav-item"
                        onClick={() => handleTab("Holdings")}
                    >
                        <Nav.Link eventKey="Holdings">Holding</Nav.Link>
                    </li>
                    <li
                        className="nav-item"
                        onClick={() => handleTab("NetPosition")}
                    >
                        <Nav.Link eventKey="NetPosition">Net Position</Nav.Link>
                    </li>
                </Nav>
                <div className="btn-wrapper-summary">
                    <img src={refresh} onClick={apiCall} style={{ cursor: "pointer" }} />
                    <button
                        value="excel"
                        onClick={handleOnClick}
                        className="summary-btn excel-btn"
                    >
                        {smallLoaderExcel ? (
                            <div>
                                <SmallLoader />
                            </div>
                        ) : (
                            <>
                                <span className="icon-excelsvg"></span>
                                Excel
                            </>
                        )}
                    </button>
                    <button
                        className="summary-btn pdf-btn"
                        value="pdf"
                        onClick={handleOnClick}
                    >
                        {smallLoaderPdf ? (
                            <div>
                                <SmallLoader />
                            </div>
                        ) : (
                            <>
                                <span className="icon-pdfsvg"></span>
                                PDF
                            </>
                        )}
                    </button>
                </div>
            </div>
            <Tab.Content>
                {tabStatus == "Holdings" ?
                    <PartnerHoldings loader={loader} holdingData={holdingData} commonError={commonError} handleOnClick={handleOnClick} smallLoaderExcel={smallLoaderExcel} smallLoaderPdf={smallLoaderPdf} totalValue={totalValue} />
                    :
                    <PartnerNetPosition loader= {loader} positionData={positionData} setPostionData={setPostionData} commonError={commonError} handleOnClick={handleOnClick} smallLoaderExcel={smallLoaderExcel} smallLoaderPdf={smallLoaderPdf} />
                }
            </Tab.Content>
          </Tab.Container>

      </div>
    </div>
    </div>
  );
}

export default PartnerHoldingsNetPosition;
